import { useState } from "react";
import { Button, Dialog, DialogContent, DialogActions, useMediaQuery } from "@mui/material";
// material
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
// components
import Page from "../components/Page";
import { LoginForm } from "../components/authentication/login";
// import AuthSocial from '../components/authentication/AuthSocial';
import Translate from "../utils/Translate";
import Preloader from "../components/Preloader";
import { getQueryParam } from "../utils/uriHelper";
import CookieConsent from "../components/CookieConsent";
import { useSearchParams } from "react-router-dom";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: "flex",
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: window.global.isEcomp ? 1200 : 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  //padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

function getLoginPageClassName(smallScreen) {
  if (window.global.isKs) {
    return smallScreen ? "loginPagePermitsMobile" : "loginPagePermits";
  } else if (window.global.isEcomp) {
    return smallScreen ? "loginPageECompMobile" : "loginPageEComp";
  } else {
    return "loginPage";
  }
}

export default function Login({ redirectPath, defaultLoginMethod }) {
  const [dataFetched, setDataFetched] = useState(false);
  const [isTimeout, setIsTimeout] = useState(getQueryParam("timeout"));
  const [isLogout, setIsLogout] = useState(getQueryParam("logout"));
  const [showQrCodeOnDesktop] = useState(!(getQueryParam("logout") && true));
  const smallScreen = useMediaQuery("(max-width:700px)");
  const [searchParams] = useSearchParams();
  const isDigitalLicenseContact = !!searchParams.get("digitalLicensePublishGroupId");
  const isDigitalLicensePublic = !!searchParams.get("digitalLicenseId");

  // Excluding isDigitalLicenseContact and isDigitalLicensePublic, because sometimes the Translate.loadPreLogin
  // will finish after the Translate.loadApp called in these cases, overwriting the loaded translations
  if (!dataFetched && !isTimeout && !isDigitalLicenseContact && !isDigitalLicensePublic) {
    if (!sessionStorage.translation) {
      /*  let lang=9;
      if (localStorage.lang) {
        lang = localStorage.lang;
      } 
       Translate.loadPreLogin(lang).then
      */
      Translate.loadPreLogin(false).then((data) => {
        setDataFetched(true);
      });
    } else {
      setDataFetched(true);
    }
  }

  function handleTimeoutOk() {
    setIsTimeout(false);
  }

  function handleLogOutOk() {
    setIsLogout(false);
  }

  return (
    <RootStyle className={getLoginPageClassName(smallScreen)}>
      {!dataFetched && !isTimeout && <Preloader />}
      <CookieConsent />

      {isTimeout && (
        <Dialog open={true}>
          <DialogContent>{Translate.get("LoggedOutTimeout")}</DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleTimeoutOk}>
              {Translate.get("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {isLogout && (
        <Dialog open={true}>
          <DialogContent>{Translate.get("YouAreNowLoggedOut")}</DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleLogOutOk}>
              {Translate.get("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!(isTimeout || isLogout) && (
        <Container maxWidth={window.global.isEcomp ? "lg" : "sm"}>
          <ContentStyle>
            <LoginForm
              redirectPath={redirectPath}
              defaultLoginMethod={defaultLoginMethod}
              startQrCodeOnDesktop={showQrCodeOnDesktop}
            />
          </ContentStyle>
        </Container>
      )}
    </RootStyle>
  );
}
